var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"description-block"},[_c('div',{ref:"element",staticClass:"element",class:_vm.background},[_vm._t("default")],2),(_vm.show)?_c('pre',{staticClass:"description"},[_vm._v(_vm._s(_vm.prettifyXml(_vm.$refs.element.innerHTML)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }